import { CustomerPaymentCtrl }       from './customer-payment';
import { CustomerPaymentsCtrl }      from './customer-payments';
import { CustomerPaymentsDirective } from './customer-payments.directive';
import { CustomerPaymentStates }     from './customer-payments.states.ajs';

angular.module('workshop.customerPayments', [])
  .config(CustomerPaymentStates)
  .controller('customerPaymentCtrl', CustomerPaymentCtrl)
  .controller('CustomerPaymentsCtrl', CustomerPaymentsCtrl)
  .directive('customerPayments', CustomerPaymentsDirective);
